import { Button, Form, Modal, Radio, Select } from 'antd';
import { useContext } from 'react';
import { useHistory } from 'react-router-dom';

import { FormLineLayout } from 'app/components/commons/Form/FormLineLayout/FormLineLayout';
import { ViewEditModeContext } from 'app/context/ViewEditModeContext/ViewEditModeContext';
import { useHotels } from 'app/hooks/data/hotels/useHotel';

import { RULES } from '../../Hotels/HotelDetail/Finance/utils';

import './NewPackModal.scss';

const { Option } = Select;

type NewPackModalForm = {
  isDaytime: boolean;
  hotelId?: number;
};

type NewPackModalProps = {
  open: boolean;
  onClose: () => void;
  hotelId?: number;
};

export const NewPackModal = ({ open, onClose, hotelId }: NewPackModalProps) => {
  const { enterViewMode } = useContext(ViewEditModeContext);
  const [form] = Form.useForm();
  const formValues = Form.useWatch([], form);
  const { data: hotels } = useHotels();
  const history = useHistory();

  const handleOk = async (values: NewPackModalForm) => {
    const isLegacy = hotels?.find((h) => h.id === values.hotelId)?.isLegacy;

    enterViewMode();

    const url = isLegacy ? '/packs/legacy/new' : '/packs/new';

    history.push({
      pathname: url,
      search: `?hotelId=${values.hotelId}&isDaytime=${values.isDaytime}`,
    });
  };

  return (
    <Modal
      title="Create new package"
      open={open}
      width={572}
      closable
      destroyOnClose
      onCancel={onClose}
      centered
      className="new-pack-modal"
      footer={[
        <Button key="cancel" onClick={onClose}>
          No
        </Button>,
        <Button key="ok" onClick={form.submit} type="primary" loading={false}>
          Yes
        </Button>,
      ]}
    >
      <Form
        onFinish={handleOk}
        form={form}
        initialValues={{ isDaytime: false, hotelId }}
        layout="vertical"
        className="new-pack-modal-form"
      >
        <FormLineLayout label="Type" isRequired isInModal>
          <Form.Item name="isDaytime" rules={RULES}>
            <Radio.Group>
              <Radio value={false}>Night stay</Radio>
              <Radio value={true}>Daytime</Radio>
            </Radio.Group>
          </Form.Item>
        </FormLineLayout>
        {formValues && (
          <FormLineLayout label="Hotel" isRequired isInModal>
            <Form.Item name="hotelId" rules={RULES}>
              <Select
                placeholder="Select a hotel"
                showSearch
                optionFilterProp="children"
                disabled={!!hotelId}
              >
                {hotels?.map((option) => (
                  <Option key={option.id} value={option.id}>
                    {option.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </FormLineLayout>
        )}
      </Form>
    </Modal>
  );
};
